import type { HourRow } from "../../components/types.js"
import { MOON_ID } from "../celestialIcons.js"
import { getTopPicks as computeTopPicks } from "../topPicks.js"
import {
  formatTimeForDisplayUTC,
  getDayOffset,
  parseHorizonsTimeUtc,
  formatTimeForDisplay,
} from "../timezones.js"

export type TimeDisplay = { time: string; dayOffset: number }

export type EphemerisRowViewModel = {
  row: HourRow
  utcTime: string
  obsTime: string
  obsDayOffset: number
  mineTime: string
  mineDayOffset: number
}

export type TrackerViewModel = {
  topPicks: EphemerisRowViewModel[]
  allRows: EphemerisRowViewModel[]
}

function utcToTzTime(
  utcTime: string,
  timezone: string | null
): TimeDisplay {
  const date = parseHorizonsTimeUtc(utcTime)
  if (!date) return { time: utcTime, dayOffset: 0 }

  if (timezone) {
    return {
      time: formatTimeForDisplay(date, timezone),
      dayOffset: getDayOffset(date, timezone),
    }
  }

  return {
    time: formatTimeForDisplay(date, null),
    dayOffset: getDayOffset(date, null),
  }
}

function toRowVm(
  row: HourRow,
  observatoryTimezone: string | null
): EphemerisRowViewModel {
  const utcTime = formatTimeForDisplayUTC(row.time)
  const obs = observatoryTimezone
    ? utcToTzTime(row.time, observatoryTimezone)
    : { time: "—", dayOffset: 0 }
  const mine = utcToTzTime(row.time, null)

  return {
    row,
    utcTime,
    obsTime: obs.time,
    obsDayOffset: obs.dayOffset,
    mineTime: mine.time,
    mineDayOffset: mine.dayOffset,
  }
}

export function buildTrackerViewModel(input: {
  rows: HourRow[]
  celestialObjectRecordNumber: string | null
  observatoryTimezone: string | null
}): TrackerViewModel {
  const isMoon = input.celestialObjectRecordNumber === MOON_ID
  const topPickRows = computeTopPicks(input.rows, isMoon)

  return {
    topPicks: topPickRows.map(r => toRowVm(r, input.observatoryTimezone)),
    allRows: input.rows.map(r => toRowVm(r, input.observatoryTimezone)),
  }
}


